
//HomeScreen Component
export const getParkingDimensionsUrl = `/parking/getParkingDimensions`;
export const getParkingTypesUrl = `/parking/getParkingTypes`;
export const getAllSlotsUrl = `/parking/getAllSlots`;
export const sendNotifyRequestMeUrl = `/bookings/set-notification-book-slot`;

//TakeTour Compons=ent
export const takeSiteTourUrk = `/tour/book-tour`;

//MyBooking Component
export const getMybookinListUrl = `/bookings/list`;

//Vehicles Component
export const getMyVehicleListUrl = `/user/profile/vehicles`;
export const getVehicleTypesUrl = `/user/profile/getVehicleTypes`;
export const addNewVehicleUrl = `/user/profile/vehicle/add`;


//UserProfile Component
export const getUserDetailsUrl = `/user`;
export const getUserDetail = `/user/profile/get-profile`;

//Edit user data
export const edituserDetailsUrl = '/user/profile/update-profile';

//ChangePassword
export const changePasswordUrl = `/user/change-password`;

//Onboarding Components
export const loginUrl = `/user/login`;
export const googleLoginUrl = `/user/social-login/google`;
export const signUpUrl = `/user/sign-up`;

export const forgetPasswordGetOtpUrl = `/user/forgot-password`;
export const verifyOtpforResetPassUrl = `/user/verify-otp`;
export const resetPasswordEmailUrl = `/user/reset-password/email`;
export const resetPasswordPhoneUrl = `/user/reset-password/phone`;

export const rqstOtpForEmailVerificationUrl = `/user/send-verification/email`;
export const rqstOtpForPhoneVerificationUrl = `/user/send-verification/phone`;
export const verifyEmailOtpUrl = `/user/verify/email`;
export const verifyPhoneOtpUrl = `/user/verify/phone`;


//CardDetails
export const getMyCardsListUrl = `/user/user-cards`;
export const addNewCardUrl = `/user/add-new-card`;
export const updatePreviousCardUrl = `/user/update-card`;
export const getCardDetailById = `/user/get-card-details`
export const deleteCard = `/user/delete-card`

//Subscription Plans
export const getSubscriptionPlansUrl = `/bookings/get-subscription-plans`;

//Get booking id
export const confirmBookNewSlotUrl = `/bookings/book-slot`;

//confirm booking with subscription
export const createSubscriptionBookingUrl = `/subscriptions/create-subscription`;

//Validate CVV
export const validateCvvForBooking = `/user/validate-card-cvv`;

//Cancel my Booking
export const cancelBookingUrl = `/bookings/cancel-booking`;


//Report list
export const reportListUrl = `/reporting/get-all-categories`;

//Submit report Issue
export const submitReportUrl = `/reporting/report-new-issue`;

//maintenance
export const generateAccessToken = `/bookings/generate-access-code`;
export const getBookings = `/bookings/list?pageNo=1&pageSize=10`
